"use client";

import { FC } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/app/components/shadcn/form";
import { Button } from "@/app/components/shadcn/button";
import { PhoneInput } from "@/app/components/elements/forms/phoneInput/PhoneInput";
import { UseFormReturn } from "react-hook-form";
import { LoginPhoneData } from "@/app/schemas/loginSchema";
import CountdownError from "../shared/CountdownError";

interface LoginPhoneFormProps {
  form: UseFormReturn<LoginPhoneData>;
  isLoading?: boolean;
  error?: string | null;
  onErrorClear?: () => void;
}

const LoginPhoneForm: FC<LoginPhoneFormProps> = ({
  form,
  isLoading,
  error,
  onErrorClear,
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium text-gray-700">
              Telefon Numarası *
            </FormLabel>
            <FormControl>
              <PhoneInput
                className="h-12"
                value={field.value}
                onChange={field.onChange}
                onCountryChange={(countryId) => {
                  form.setValue("countryId", countryId);
                }}
                disabled={isLoading}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <CountdownError error={error} onClear={onErrorClear} />

      <Button
        type="submit"
        className="w-full h-12 text-base font-medium"
        disabled={isLoading}
      >
        {isLoading ? "Kod gönderiliyor..." : "Kod Gönder"}
      </Button>
    </>
  );
};

export default LoginPhoneForm;